import React from 'react';
import { Card, CardContent, Button } from '@material-ui/core';
import clsx from 'clsx';
import styles from './styles';

const DATA = {
  id: 'Co104',
  stat: 'searching',
  req: '15',
  date: '12-02-2020',
  loc: 'LA 2664',
  size: '40 FT',
  pro: 'one',
};

export default (props) => {
  const cls = styles();

  return (
    <Card className={cls.card}>
      <div className={cls.header}>
        <span>{'ID: ' + DATA.id}</span>
        <span>{'Status: ' + DATA.stat}</span>
      </div>
      <CardContent className={cls.content}>
        <div className={clsx(cls.row, cls.bigRow)}>
          <span>Your request</span>
          <span className={cls.bigText}>{DATA.req}</span>
        </div>
        <div className={cls.row}>
          <span className={cls.light}>Date:</span>
          <span>{DATA.date}</span>
        </div>
        <div className={cls.row}>
          <span className={cls.light}>Location:</span>
          <span>{DATA.loc}</span>
        </div>
        <div className={cls.row}>
          <span className={cls.light}>Size:</span>
          <span>{DATA.size}</span>
        </div>

        <div className={cls.row}>
          <span className={cls.light}>SSL:</span>
          <span>{DATA.pro}</span>
        </div>
        <div className={cls.hr} />

        <div className={cls.butCont}>
          <Button className={cls.but}>Edit</Button>
          <Button className={clsx(cls.but, cls.red)}>Reject</Button>
        </div>
      </CardContent>
    </Card>
  );
};
